// Grouped controllers for lazy loading
export const controllerGroups = {
    editor: [
        './components/editor_js_controller.js'
    ],
    font_upload: [
        './font_upload/font_file_uploader_controller.js',
        './font_upload/font_preview_uploader_controller.js',
        './font_upload/font_variants_manager_controller.js',
        './font_upload/license_scope_controller.js',
        './font_upload/sortable_controller.js'
    ]
    // Future groups can be added here
    // analytics: ['./components/analytics_controller.js'],
    // admin: ['./admin/dashboard_controller.js', './admin/stats_controller.js']
}

// Get all lazy controllers (for main app to exclude)
export const getAllLazyControllers = () => {
    return Object.values(controllerGroups).flat()
}

// Get controllers for specific group
export const getGroupControllers = (groupName) => {
    return controllerGroups[groupName] || []
}